import clsx from 'clsx';
import React, { useCallback } from 'react';

import Checkbox from '@/src/components/common/Elements/Checkbox/Checkbox';

import { getBounce, getDisplayAvatar, getFullLabel } from '../Helper';

const Option = ({ option, onSelectOption, tags }) => {
  const checked = tags.map((s) => s.value).indexOf(option.value) !== -1;
  const selectOption = { option, checked };
  const avatar = getDisplayAvatar(option, 'optionUsers');
  const fullLabel = getFullLabel(option);
  const isBounceEmail = getBounce(option);
  const handleSelectOption = !isBounceEmail ? onSelectOption.bind(null, selectOption) : null;

  return (
    <div
      className={clsx(
        'container-recipientOptionItem',
        'tw-group',
        'tw-flex tw-items-center',
        'tw-px-[12px] tw-py-[10px]',
        'tw-cursor-pointer',
        'hover:tw-bg-cfo-blue-200'
      )}
      key={option.value}
      role="button"
      tabIndex={0}
      onClick={handleSelectOption}
      onKeyDown={handleSelectOption}
    >
      <Checkbox
        checked={checked}
        disabled={isBounceEmail}
        className={clsx(isBounceEmail && 'tw-border-cfo-grey-400')}
      />

      <div className={clsx('tw-flex tw-items-center')}>
        {avatar}
        <span
          className={clsx(
            isBounceEmail ? 'tw-text-cfo-grey-600' : 'tw-text-cfo-black',
            'tw-ml-[3px]'
          )}
        >
          {fullLabel}
        </span>
      </div>
    </div>
  );
};

export default Option;
